import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const useRouteChangeDetection = (route: string, cb: () => void) => {
  const location = useLocation();
  const previousPathnameRef = useRef<string | null>(null);

  useEffect(() => {
    const currentPathname = location.pathname;
    const previousPathname = previousPathnameRef.current;

    if (
      previousPathname &&
      previousPathname.startsWith(route) &&
      !currentPathname.startsWith(route)
    ) {
      cb();
    }

    previousPathnameRef.current = currentPathname;
  }, [location.pathname, route, cb]);
};

export default useRouteChangeDetection;
